const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(entity => ({
    ...entity,
    minorityPercentage: isNaN(entity.minorityPercentage) ? null : entity.minorityPercentage,
    legalEntity: entity.legalEntity ? `${entity.legalEntity}`: '',
    source: entity.source ? `${entity.source}`: '',
    goldId: entity.goldId ? `${entity.goldId}`: '',
    parent1: entity.parent1 ? `${entity.parent1}` : '',
    parent2: entity.parent2 ? `${entity.parent2}` : '',
    parent3: entity.parent3 ? `${entity.parent3}` : '',
    parent4: entity.parent4 ? `${entity.parent4}` : '',
    parent5: entity.parent5 ? `${entity.parent5}` : '',
    parent6: entity.parent6 ? `${entity.parent6}` : '',
    parent7: entity.parent7 ? `${entity.parent7}` : '',
    parent8: entity.parent8 ? `${entity.parent8}` : '',
    parent9: entity.parent9 ? `${entity.parent9}` : '',
    parent10: entity.parent10 ? `${entity.parent10}` : '',
  }));

export default fixDataTypes;
